import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from 'sweetalert2'; 
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config/api";
import {
  FaChild,
  FaFilter,
  FaRulerCombined,
  FaShoppingCart,
  FaTimes,
  FaEye,
} from "react-icons/fa";

const getUniformImageUrl = (uniform) => {
  const imagePath =
    Array.isArray(uniform?.images) && uniform.images.length > 0
      ? uniform.images[0]
      : uniform?.image;

  if (!imagePath) return "https://via.placeholder.com/260x220?text=No+Image";

  const cleanPath = String(imagePath)
    .replace(/\\/g, "/")
    .replace(/^\/+/, "");

  if (cleanPath.startsWith("http")) return cleanPath;
  if (cleanPath.startsWith("uploads/")) return `${API_BASE_URL}/${cleanPath}`;

  return `${API_BASE_URL}/uploads/${cleanPath}`;
};

function ParentUniformPage() {
  const navigate = useNavigate();
  const [schoolName, setSchoolName] = useState("");
  const [uniforms, setUniforms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [houses, setHouses] = useState([]);

  // Child State
  const [children, setChildren] = useState(() => {
    const childName = localStorage.getItem("childName") || "Child";
    return [
      {
        id: localStorage.getItem("parentId") || "registered-child",
        name: childName,
        house: "Any",
        gender: "",
        season: "Any",
      },
    ];
  });
  const [activeIndex, setActiveIndex] = useState(0);

  // Size Guide States
  const [showModal, setShowModal] = useState(false);
  const [chartImages, setChartImages] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState({});

  // Size Charts Configuration
  const sizeChartMap = {
    Pant: ["/sizechart/Formal-Pent-Size.jpeg", "/sizechart/pant-1.jpeg"],
    Jeans: ["/sizechart/Jeans-size.jpeg", "/sizechart/jeans-1.jpeg"],
    Blazer: ["/sizechart/Blazer-size.jpeg", "/sizechart/blazer-1.jpeg"],
    // Aap aur categories yahan add kar sakte hain
  };

  useEffect(() => {
    const schoolId = localStorage.getItem("schoolId");
    if (schoolId) {
      setSchoolName(localStorage.getItem("schoolName") || "Official School Store");
      loadRegisteredChildName();
      loadHouses();
    }
  }, []);

  const loadRegisteredChildName = async () => {
    const storedChildName = localStorage.getItem("childName");
    if (storedChildName) return;

    const parentId = localStorage.getItem("parentId");
    if (!parentId) return;

    try {
      const res = await axios.get(`${API_BASE_URL}/parent/parent/${parentId}`);
      const childName = res.data?.childName;
      if (childName) {
        localStorage.setItem("childName", childName);
        setChildren((prev) =>
          prev.map((child, index) => index === 0 ? { ...child, name: childName } : child)
        );
      }
    } catch (err) {
      console.error("Child name fetch failed", err);
    }
  };

  useEffect(() => {
    handleFilter();
     if (children[activeIndex]) {
    localStorage.setItem("activeChildId", children[activeIndex].id);
  }
  }, [activeIndex, children]);

  const loadHouses = async () => {
    try {
      const res = await axios.post(`${API_BASE_URL}/uniform/filter`, {
        schoolId: localStorage.getItem("schoolId"),
      });
      const uniqueHouses = [...new Set(res.data.map((u) => u.house).filter(Boolean))];
      setHouses(uniqueHouses);
    } catch (err) {
      console.error(err);
    }
  };

  const handleFilter = async () => {
    setLoading(true);
    const child = children[activeIndex];
    try {
      const res = await axios.post(`${API_BASE_URL}/uniform/filter`, {
        schoolId: localStorage.getItem("schoolId"),
        gender: child.gender || undefined,
        house: child.house !== "Any" ? child.house : undefined,
        season: child.season !== "Any" ? child.season : undefined,
      });
      setUniforms(res.data);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  const saveToDatabase = async (updatedData) => {
    const parentId = localStorage.getItem("parentId");
    if (!parentId) return;
    try {
      await axios.put(`${API_BASE_URL}/parent/update-selections/${parentId}`, {
        children: updatedData,
      });
    } catch (err) {
      console.error("Database update failed ❌", err);
    }
  };

  const deleteChild = (id, e) => {
    e.stopPropagation();
    if (children.length > 1) {
      Swal.fire({
        title: 'Remove Profile?',
        text: "Are you sure you want to delete this child's profile?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Yes, remove it!'
      }).then((result) => {
        if (result.isConfirmed) {
          const updated = children.filter((c) => c.id !== id);
          setChildren(updated);
          setActiveIndex(0);
        }
      });
    } else {
      Swal.fire({ title: 'Note', text: 'At least one profile must remain.', icon: 'info' });
    }
  };

  const handleProductOption = (uniformId, field, value) => {
    setSelectedOptions((prev) => ({
      ...prev,
      [uniformId]: { ...prev[uniformId], [field]: value },
    }));
  };

  // Open Size Guide Function
  const openSizeGuide = (category) => {
    const images = sizeChartMap[category] || [];
    if (images.length > 0) {
      setChartImages(images);
      setShowModal(true);
    } else {
      Swal.fire({
        icon: 'info',
        title: 'Not Available',
        text: 'Size chart for this category will be available soon.',
        timer: 1500,
        showConfirmButton: false
      });
    }
  };

const addToCart = async (uniformId) => {

  const option = selectedOptions[uniformId];

  if (!option?.size) {
    Swal.fire({
      icon:"warning",
      title:"Select Size"
    });
    return;
  }

  try {

    await axios.post(`${API_BASE_URL}/cart/add`, {

      parentId: localStorage.getItem("parentId"),
      childId: children[activeIndex].id,
      uniformId: uniformId,
      size: option.size,
      quantity: option.quantity || 1

    });

    // Dispatch cart update event to refresh header counter
    window.dispatchEvent(new Event("cartUpdate"));

    Swal.fire({
      icon:"success",
      title:"Added To Cart",
      timer:1500,
      showConfirmButton:false
    });

  } catch (err) {

    console.log(err);

  }

};

  const getStockInfo = (u) => {
    if (u.status === "outofstock" || u.stock <= 0) {
      return { label: "Sold Out", class: "st-unavailable", disabled: true };
    }
    if (u.stock < 5) {
      return { label: `Only ${u.stock} Left`, class: "st-low", disabled: false };
    }
    return { label: "In Stock", class: "st-available", disabled: false };
  };

  return (
    <div className="ultra-premium-page">
      <section className="hero-animated">
        <div className="container text-center">
          <h1 className="school-title-animated">{schoolName}</h1>
          <p className="hero-subtitle">Uniforms for <b>{children[activeIndex].name}</b></p>
        </div>
      </section>

      <div className="container py-5">
        <div className="row g-4">
          <aside className="col-lg-3">
            <div className="glass-sidebar">
              <h5 className="section-title"><FaChild className="text-primary me-2" /> Profiles</h5>
              <div className="profile-list mb-4">
                {children.map((child, index) => (
                  <div key={child.id} className={`profile-card ${activeIndex === index ? "active" : ""}`} onClick={() => setActiveIndex(index)}>
                    <div className="avatar-circle">{child.name.charAt(0)}</div>
                    <span className="flex-grow-1 ms-2">{child.name}</span>
                  </div>
                ))}
              </div>
              <hr />
              <h5 className="section-title mt-4"><FaFilter className="text-primary me-2" /> Filters</h5>
              <div className="filter-controls">
                <label className="small-label">Gender</label>
                <select className="modern-input" value={children[activeIndex].gender} onChange={(e) => { const updated = [...children]; updated[activeIndex].gender = e.target.value; setChildren(updated); }}>
                  <option value="">Any Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
                <label className="small-label">House</label>
                <select className="modern-input" value={children[activeIndex].house} onChange={(e) => { const updated = [...children]; updated[activeIndex].house = e.target.value; setChildren(updated); }}>
                  <option value="Any">Any House</option>
                  {houses.map((h, i) => <option key={i} value={h}>{h}</option>)}
                </select>
               
              </div>
            </div>
          </aside>

          <main className="col-lg-9">
            <div className="row g-4">
              {loading ? (
                <div className="text-center py-5 w-100"><div className="loader-custom"></div></div>
              ) : uniforms.length === 0 ? (
                <div className="empty-state text-center py-5 w-100"><h5>No uniforms found.</h5></div>
              ) : (
                uniforms.map((u) => {
                  const option = selectedOptions[u._id] || { quantity: 1 };
                  const stock = getStockInfo(u);
                  return (
                    <div className="col-md-6 col-xl-4" key={u._id}>
                      <div className={`product-premium-card ${stock.disabled ? "is-out" : ""}`}>
                        <div className="card-top">
                          <div className={`stock-badge-premium ${stock.class}`}>{stock.label}</div>
                          
                          {/* ⭐ Floating Size Guide Button */}
                          {!stock.disabled && (
                            <button className="size-guide-badge-btn" onClick={() => openSizeGuide(u.sizeCategory)}>
                              <FaRulerCombined /> Guide
                            </button>
                          )}

                          <img src={getUniformImageUrl(u)} alt={u.name} />
                          <div className="action-overlay">
                            <button className="circle-btn" onClick={() => navigate(`/uniform/${u._id}`)}><FaEye /></button>
                            <button className="circle-btn" onClick={() => openSizeGuide(u.sizeCategory)}><FaRulerCombined /></button>
                          </div>
                        </div>

                        <div className="card-bottom">
                          <h6 className="item-name text-truncate">{u.name}</h6>
                          <p className="price-label">₹{u.price}</p>
                          <div className="d-flex gap-2 mb-3">
                    <select
  className="modern-input-sm w-100"
  disabled={stock.disabled}
  value={option.size || ""}
  onChange={(e) => handleProductOption(u._id, "size", e.target.value)}
>
  {/* 'hidden' add karne se dropdown list mein ye nahi dikhega */}
  <option value="" hidden>Size</option>
  
  {["22", "24", "26", "28", "30", "32", "34", "36", "38", "40", "42", "44"].map((sz) => (
    <option key={sz} value={sz}>
      {sz}
    </option>
  ))}
</select>
                            <div className="qty-box">
                              <button onClick={() => handleProductOption(u._id, "quantity", Math.max(1, (option.quantity || 1) - 1))}>-</button>
                              <span>{option.quantity || 1}</span>
                              <button onClick={() => handleProductOption(u._id, "quantity", (option.quantity || 1) + 1)}>+</button>
                            </div>
                          </div>
                          <button className="btn-buy-now w-100" onClick={() => addToCart(u._id)} disabled={stock.disabled}>
                            {stock.disabled ? "Sold Out" : <><FaShoppingCart className="me-2" /> Add to Cart</>}
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </main>
        </div>
      </div>

      {/* ⭐ Updated Modal for Size Guide Images */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content-premium animate-up" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header-p d-flex justify-content-between align-items-center mb-3">
              <h5 className="m-0">Size Measurement Guide</h5>
              <button className="btn border-0" onClick={() => setShowModal(false)}><FaTimes size={20}/></button>
            </div>
            <div className="modal-body-p" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              {chartImages.length > 0 ? (
                chartImages.map((img, i) => <img key={i} src={img} className="size-guide-img shadow-sm mb-3" alt="Size Chart" />)
              ) : (
                <p className="text-center py-4">No image uploaded.</p>
              )}
            </div>
          </div>
        </div>
      )}

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;800&display=swap');
        .ultra-premium-page { background: #fcfdfe; font-family: 'Plus Jakarta Sans', sans-serif; min-height: 100vh; }
        .hero-animated { background: #91c79d; padding: 60px 0; color: white; margin-bottom: 2rem; border-bottom-right-radius: 40px; border-bottom-left-radius: 40px; }
        .school-title-animated { font-weight: 800; color:white; }
        .glass-sidebar { background: white; border-radius: 20px; padding: 20px; box-shadow: 0 4px 12px rgba(0,0,0,0.05); }
        .profile-card { display: flex; align-items: center; padding: 10px; border-radius: 12px; border: 1px solid #e2e8f0; margin-bottom: 8px; cursor: pointer; }
        .profile-card.active { border-color: #3b82f6; background: #eff6ff; }
        .avatar-circle { width: 30px; height: 30px; background: #3b82f6; color: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; }
        .product-premium-card { background: white; border-radius: 20px; border: 1px solid #f1f5f9; overflow: hidden; transition: 0.3s; position: relative; }
        .is-out { opacity: 0.6; }
        .stock-badge-premium { position: absolute; top: 12px; left: 12px; padding: 4px 10px; border-radius: 8px; font-size: 0.65rem; font-weight: 800; z-index: 10; text-transform: uppercase; }
        
        /* Size Guide Floating Button */
        .size-guide-badge-btn { 
            position: absolute; top: 12px; right: 12px; z-index: 10; 
            background: rgba(255,255,255,0.9); border: 1px solid #eee; 
            border-radius: 20px; padding: 4px 12px; font-size: 0.7rem; 
            font-weight: 700; color: #097969; box-shadow: 0 2px 5px rgba(0,0,0,0.05);
            transition: 0.3s;
        }
        .size-guide-badge-btn:hover { background: #097969; color: white; }

        .st-available { background: #dcfce7; color: #166534; }
        .st-low { background: #fef9c3; color: #854d0e; }
        .st-unavailable { background: #fee2e2; color: #991b1b; }
        .card-top { position: relative; height: 220px; background: #f8fafc; display: flex; align-items: center; justify-content: center; }
        .card-top img { height: 75%; }
        .action-overlay { position: absolute; inset: 0; background: rgba(0,0,0,0.1); display: flex; align-items: center; justify-content: center; gap: 8px; opacity: 0; transition: 0.3s; }
        .product-premium-card:hover .action-overlay { opacity: 1; }
        .circle-btn { width: 40px; height: 40px; border-radius: 50%; border: none; background: white; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 8px rgba(0,0,0,0.1); }
        .card-bottom { padding: 15px; }
        .price-label { font-size: 1.2rem; font-weight: 800; color: #040404; margin-bottom: 12px; }
        .modern-input, .modern-input-sm { padding: 8px; border-radius: 10px; border: 1px solid #e2e8f0; width: 100%; outline: none; margin-bottom: 10px; }
        .qty-box { display: flex; align-items: center; background: #f1f5f9; border-radius: 10px; padding: 0 5px; height: 38px;}
        .qty-box button { border: none; background: none; padding: 5px 8px; }
        .btn-buy-now { background: #097969; color: white; border: none; padding: 12px; border-radius: 12px; font-weight: 600; }
        .btn-buy-now:disabled { background: #94a3b8; cursor: not-allowed; }
        
        .modal-overlay { position: fixed; inset: 0; background: rgba(0,0,0,0.7); z-index: 9999; display: flex; align-items: center; justify-content: center; backdrop-filter: blur(4px); }
        .modal-content-premium { background: white; border-radius: 24px; width: 90%; max-width: 500px; padding: 25px; box-shadow: 0 20px 50px rgba(0,0,0,0.2); }
        .size-guide-img { width: 100%; border-radius: 12px; display: block; }
        .animate-up { animation: fadeInUp 0.3s ease-out; }
        @keyframes fadeInUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }

        .swal2-popup { border-radius: 20px !important; font-family: 'Plus Jakarta Sans', sans-serif !important; }
      `}</style>
    </div>
  );
}

export default ParentUniformPage;
